export default {
    namespace: 'app',
    state: {
        path: null,
    },
    reducers: {
        page_load(state, action) {
            const {path} = action.payload;
            return Object.assign({}, state, {path});
        }
    },
}



// WEBPACK FOOTER //
// ./src/model/app.js